export default __webpack_public_path__ + "static/media/Git.29120e83.svg";